import { getCookie } from './cookies'

export async function fetchAsync(_url, _body, _method, _header, _token) {
  const tokenBearer = getCookie('token')
  // const tokenBearer = getCookie('token' + "12")
  let headerC = new Headers({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With',
    'Authorization': tokenBearer,
  });
  var data;

  if (_body === '') {
    let options = {
      method: _method,
      headers: headerC
    }
    data = await fetch(_url, options)
      .then(response => response.json())
      .then(data => data)
  } else {
    let options = {
      method: _method,
      headers: headerC,
      body: _body,
    }
    data = await fetch(_url, options)
      .then(response => response.json())
      .then(data => data)
  }

  return data;
}

//Upload data to S3 aws.
export function uploadData3(_url, _body, _method) {
  let xhr = new XMLHttpRequest()
  let returnPromise = new Promise((res, rej) => {
    xhr.open(_method, _url)
    xhr.setRequestHeader('Content-Type', _body.type);
    xhr.onload = e => res(e.target.responseText);
    xhr.onerror = rej

    //UNCOMMENT TO SEE THE PERCENTAGE OF THE UPLOADING IMAGE
    // xhr.upload.onprogress = function (event) {
    //   if (event.lengthComputable) {
    //     var percent = Math.round((event.loaded / event.total) * 100)
    //     // console.log(percent)
    //   }
    // }
    xhr.send(_body)
  })
  returnPromise.abort = () => {
    xhr.abortn()
  }
  return returnPromise
}


// export function uploadData3(_url, _body, _method, onProgress, index) {
//   let xhr = new XMLHttpRequest()
//   let returnPromise = new Promise((res, rej) => {
//     xhr.open(_method, _url)
//     xhr.setRequestHeader('Content-Type', _body.type);
//     xhr.onload = e => res(e.target.responseText);
//     xhr.onerror = rej
//     xhr.upload.onprogress = function (event) {
//       if (event.lengthComputable) {
//         var percent = Math.round((event.loaded / event.total) * 100)
//         onProgress(percent, index)
//         // console.log(percent)
//       }
//     }
//     xhr.send(_body)
//   })
//   returnPromise.abort = () => {
//     xhr.abortn()
//   }
//   return returnPromise
// }


// export const fetcherTwo = (endpoint = '', props = {}) => {
//   const headers = {
//     ...props.headers,
//     'Content-Type': 'application/json',
//     'Cache-Control': 'no-cache'
//   };

//   if (!endpoint.includes('login') && !headers.Authorization) {
//     headers['Authorization'] = getCookie('token');
//   }

//   return fetch(urlBase + endpoint, {
//     ...props,
//     headers,
//     mode: 'cors'
//   })
//     .then((response) => response.json())
//     .catch((error) => ({ success: false, error }));
// };


